import React, { useState, useEffect, useCallback } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../CssFiles/testimonial.css";

const quoteicon = "https://loans.imimg.com/desktop_react/src/Images/testimonialimages/quote.png";
const quoteicon1 = "https://loans.imimg.com/desktop_react/src/Images/testimonialimages/quote1.png";
const quoteicon2 = "https://loans.imimg.com/desktop_react/src/Images/testimonialimages/quote2.png";
const line = "https://loans.imimg.com/desktop_react/src/Images/testimonialimages/line.png";
const location = "https://loans.imimg.com/desktop_react/src/Images/testimonialimages/location.png";
const quote = "https://loans.imimg.com/desktop_react/src/Images/testimonialimages/commentquote.png";

const img1 =
  "https://loans.imimg.com/images/loans/testimonialimages/testimonial_img1.png";
const img2 =
  "https://loans.imimg.com/images/loans/testimonialimages/testimonial_img2.png";
const img3 =
  "https://loans.imimg.com/images/loans/testimonialimages/testimonial_img3.png";
const img4 =
  "https://loans.imimg.com/images/loans/testimonialimages/testimonial_img4.png";

const TestimonialsComponent = () => {
  const [slidesToShow, setSlidesToShow] = useState(2.5);

  const updateSlidesToShow = useCallback(() => {
    if (window.innerWidth >= 1000 && window.innerWidth <= 1200) {
      setSlidesToShow(3);
    } else if (window.innerWidth > 1200 && window.innerWidth < 1400) {
      setSlidesToShow(3);
    } else if (window.innerWidth > 1400) {
      setSlidesToShow(3);
    } else {
      setSlidesToShow(2.5);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", updateSlidesToShow);
    updateSlidesToShow();
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, [updateSlidesToShow]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed:3000,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1, // Ensure one slide is shown on mobile
          slidesToScroll: 1,
          arrows: false, // Optionally hide arrows on smaller screens
        },
      },
    ],
  };
  

  return (
    <>
      <section
        style={{
          paddingBottom: "20px",
          paddingTop: "25px",
          marginTop: "20px",
          background: "#F2F5F9",
          fontFamily: "Manrope",
        }}
      >
        <div style={{ display: "flex", paddingLeft: "5%" }}>
          <h2 className="title" style={{ marginBottom: "0px" }}>
            <span>Discover What Our Customers Say</span>
          </h2>
          <span style={{ width: "48%", marginLeft: "19px" }}>
            <img src={line} className="linestyle" alt="line" />
          </span>
        </div>
      </section>

      <section
        style={{
          background: "#F2F5F9",
          paddingLeft: "5px",
          paddingRight: "5px",
          overflow: "hidden",
          marginBottom: "22px",
          height: "510px",
          fontFamily: "Manrope",
        }}
        className="testimonial"
      >
        <Slider {...settings}>
          {[img1, img2, img3, img4].map((img, index) => (
            <div key={index}>
              <div
                style={{
                  display: "grid",
                  justifyContent: "center",
                  background: "#F2F5F9",
                }}
              >
                <img
                  style={{
                    maxHeight: "30px",
                    zIndex: "100",
                    position: "relative",
                    marginBottom: "-38px",
                    left: "75%",
                  }}
                  src={
                    index === 0
                      ? quoteicon
                      : index === 1
                      ? quoteicon1
                      : quoteicon2
                  }
                  alt="quote"
                />
                <img
                  style={{ maxHeight: "130px", zIndex: "50" }}
                  src={img}
                  alt="testimonial"
                />
              </div>
              <img
                style={{
                  marginTop: "-23px",
                  marginLeft: "55px",
                  zIndex: "70",
                  position: "relative",
                }}
                src={quote}
                alt="commentquote"
              />
              <div className="testimonial-box">
                <div
                  className="row"
                  style={{
                    fontSize: "16px",
                    lineHeight: "20px",
                    paddingBottom: "10px",
                    width: "100%",
                    paddingLeft:'8px',
                    textAlign:'left'
                  }}
                >
                  <div className="col-12">
                  {index === 0
                      ? "Easy Process - Seamless Support!"
                      : index === 1
                      ? "Digital Loan - Minimal Documentation"
                      : index === 2
                      ? "Best Experience - Constant Support"
                      : "Smooth Process - Best Offers"}
                  </div>
                </div>
                <div className="row testimonial-comment">
                  {index === 0
                    ? "Thanks Team IndiaMART. You provided the best support and co-operated with me throughout the loan process. I will suggest all my references to use your services and avail loans from your platform."
                    : index === 1
                    ? "Applying for a loan was so simple and hassle-free. The customer support was very helpful and provided quick responses to all my queries."
                    : index === 2
                    ? "I highly recommend this platform for getting financial assistance. The entire process was smooth and transparent."
                    : "Great service with the best interest rates. Happy with the experience!"}
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: "16px",
                    width: "100%",
                  }}
                >
                  <div className="username">
                    {index === 0
                      ? "Ramesh Kumar"
                      : index === 1
                      ? "Suresh Patel"
                      : index === 2
                      ? "Amit Sharma"
                      : "Neha Gupta"}
                  </div>
                  <div
                    className="row justify-content-center user-location-box"
                  >
                    <div
                      className="col-auto"
                      style={{ marginLeft: "-12px", paddingRight: "0px" }}
                    >
                      <img
                        src={location}
                        alt="location"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginBottom: "-20px",
                        }}
                      />
                    </div>
                    <div
                      className="col-auto"
                      style={{
                        paddingLeft: "4px",
                        fontSize: "12px",
                        color: "#808080",
                      }}
                    >
                      {index === 0
                        ? "Delhi"
                        : index === 1
                        ? "Mumbai"
                        : index === 2
                        ? "Bangalore"
                        : "Kolkata"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>
    </>
  );
};

export default TestimonialsComponent;
